export const VALIDATION_TYPES = {
  submit: "submit",
  change: "change",
  focusout: "focusout",
  input: "input",
};

export const NO_VALUE_OPTION = "__NONE__";
